<template>
  <div class="legend-container">
    <div v-for="leg of vis.config.legend" class="legend-item" :key="leg.label">
      <div
        :class="['legend-circle', 'legend-' + leg.entries[0].entry]"
        :style="'background-color: ' + leg.entries[0].color"
      ></div>
      <div class="legend-text" v-html="parseNoBreak(leg.entries[0].label)"></div>
    </div>
  </div>
</template>
<script>
import tagParseMixin from '@/mixins/tagParseMixin';
export default {
  name: 'ChartLegend',
  mixins: [tagParseMixin],
  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
    vis: {
      type: Object,
      default: () => {},
    },
    bottomMargin: {
      type: Number,
      default: 30,
    },
  },
};
</script>
<style lang="scss">
.legend-container {
  display: flex;
  justify-content: space-evenly;
  padding: 10px 10px 0 10px;

  .legend-item {
    display: flex;
    align-items: center;
    margin-right: 10px;

    .legend-circle {
      width: 10px;
      height: 10px;
      min-width:10px;
      margin: 0 auto;
      border-radius: 50%;
      background-color: black;
      display: inline-block;
      margin-right: 5px;

    }

    .legend-text {
      font-size: rem(12);
      text-align: left;
      line-height: 1;

      @include iPadProStyles {
        font-size: rem(15);
      }
    }
  }
}
</style>
